var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-text-compose",class:{ 'alt-font': _vm.altFont }},[_c('div',{ref:"textEditor"})])}
var staticRenderFns = []

export { render, staticRenderFns }